import React from 'react';
import {
    Filter,
    List,
    Edit,
    Create,
    Show,
    SimpleShowLayout,
    Datagrid,
    TextField,
    DateField,
    SimpleForm,
    TextInput,
    DisabledInput,
    SelectInput,
    ReferenceInput,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField
} from 'react-admin';
import EntityRefField from '../components/entityRefField';

const RoleFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

export const RoleList = (props) => (
	<List title="Roles" {...props} filters={<RoleFilter />} sort={{ field: 'Name', order: 'ASC' }} >
        <Datagrid>
            <TextField source="id" />
            <TextField source="Name" />
            <TextField source="Description" />
            <ReferenceField label="Parent" source="Parent" reference="Role" linkType={false}>
                <EntityRefField source="Name" />
            </ReferenceField>
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

const RoleTitle = ({ record }) => {
	return <span>{record ? `"${record.Name ? record.Name : ''}"` : ''}</span>;
};

export const RoleShow = (props) => (
    <Show title={<RoleTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" />
            <TextField source="Description" />
			<ReferenceField label="Parent" source="Parent" reference="Role" linkType={false}>
                <TextField source="Name" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;
const validateReq = [required()];

export const RoleEdit = (props) => (
    <Edit title={<RoleTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="Name" validate={validateReq} required />
            <TextInput source="Description" validate={validateReq} required />
			<ReferenceInput label="Parent" source="Parent" reference="Role">
                <SelectInput optionText="Name" />
            </ReferenceInput>
        </SimpleForm>
    </Edit>
);

export const RoleCreate = (props) => (
    <Create title="Create Role" {...props}>
        <SimpleForm>
            <TextInput source="Name" validate={validateReq} required />
            <TextInput source="Description" validate={validateReq} required />
            <ReferenceInput label="Parent" source="Parent" reference="Role">
                <SelectInput optionText="Name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/resources/roles.js